export default "__VITE_PUBLIC_ASSET__72c74e82__"